import { useTranslation } from '../../useTranslation'

type ToggleProps = {
    label: string
    error?: { key: string; values: object }
    value: boolean
    description?: string
    onChange: (value: boolean) => void
}

const Toggle = ({ label, value, error, onChange, description }: ToggleProps) => {
    const { t } = useTranslation()
    return (
        <div>
            <div className="flex justify-between ">
                <p>{label}</p>
                <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        type="checkbox"
                        checked={value}
                        className="sr-only peer"
                        onChange={(event) => {
                            onChange(event.target.checked)
                        }}
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-hidden   rounded-full peer  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-custom_yellow"></div>
                </label>
            </div>
            {description && <p className="text-gray-400 text-sm">{description}</p>}
            {error && <p className="text-red-500 pt-2 text-sm">{(t as any)(error.key, error.values)}</p>}
        </div>
    )
}

export default Toggle
